<template>
  <div class="sepa-management">
    <h3>请输入查询条件</h3>
    <div style="display: flex;justify-content: space-between;align-items: flex-start;">
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="供应商：">
            <el-select v-model="queryParams.supplierId" placeholder="请选择">
              <el-input
                placeholder="请输入搜索内容"
                v-model="selectSupplierName" @input="inputChange" style="border-bottom: 1px solid #DCDFE6;" class="input-select">
                <i
                slot="suffix"
                class="el-icon-search"
                style="font-size: 18px;line-height: 40px;margin-right: 10px;color: black;"
              ></i></el-input>
              <el-option label="全部" :value="null"></el-option>
              <el-option :label="item.supplierName" :value="item.id" v-for="(item ,index) in supplierListSelect" :key="index"></el-option>
            </el-select>
          </el-form-item>          
          <el-form-item label="公开状态: " style="margin-left: 15px;">
            <el-select v-model="queryParams.selectStatus" placeholder="请选择">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="已公开" :value="1"></el-option>
              <el-option label="未公开" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="填料：" style="margin-left: 15px;margin-right: 15px;">
            <el-input
              placeholder="请输入搜索内容"
              v-model="queryParams.catalogueName"
              style="border-top-left-radius: 0;border-bottom-left-radius: 0;"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="info" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" plain @click="addPaddingList" 
          ><i class="el-icon-plus"></i>
          新增填料
          </el-button
        >
        <!-- <el-button type="success" plain @click="batchRelease">
        <div style="display: flex;align-items: center;"><img src="../../assets/imgs/publish.svg" style="width: 12px;margin-right: 5px;background: #f0f9eb;"><span>批量公开</span></div>
          </el-button> -->
       </div>
    </div>
    <el-table v-loading="loading" :data="queryList" @expand-change="((row,expandedRows) => { getSubTableData(row,expandedRows) })" @selection-change="selectionLineChangeHandle">
      <!-- <el-table-column type="selection" align="center"></el-table-column> -->
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            :data="subTableData[getArrayIndex(queryList, props.row)]"
            :header-cell-style="tableHeaderCellStyle"
            :cell-style="tableCellStyle"
            v-loading="subTableDataLoading"
            @selection-change="((row) => {selectionChangeHandle(row,props.row)})"
            class="sub-table"
          > 
            <!-- <el-table-column type="selection" align="center"></el-table-column> -->
            <el-table-column prop="flashColumn" label="item No." align="center"> </el-table-column>
            <el-table-column prop="weight" label="Column Size(g)" align="center"> </el-table-column>
            <el-table-column prop="particleSize" label="Particle Size(μm)" align="center">
            </el-table-column>
            <el-table-column prop="aperture" label="Pore Size(Å)" align="center"> </el-table-column>
            <el-table-column prop="cv" label="CV(ml)" align="center"> </el-table-column>
            <el-table-column label="Flow Rate(ml/min)" align="center">
              <template slot-scope="scope">
                <div>{{ `${scope.row.flowRate}-${scope.row.flowRateMax}` }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="Max Pressure(psi/bar)" align="center">
              <template slot-scope="scope">
                <div>{{ `${scope.row.pressure}/${getMaxPressure(scope.row.pressure)}` }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="columnBedSize" label="Column bed sizes" align="center">
            </el-table-column>
            <el-table-column label="供应商" align="center">
              <template slot-scope="scope">
                <div>{{ getSupplierName(scope.row.supplierId)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="Operation"  align="center" class-name="small-padding fixed-width" width="250px">
              <template slot-scope="scope">
                <el-link :underline="false" @click="handleEditDetail(scope.row,props.row)" style="margin-right: 10px;" v-if="scope.row.status == 0"
                  ><img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>编辑</span></el-link
                >
                <el-link :underline="false" @click="handleDetail(scope.row,props.row)" style="margin-right: 10px;" v-if="scope.row.status == 1"
                  ><img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>查看</span></el-link
                >
                <el-link :underline="false" @click="handlePublish(scope.row)" style="margin-right: 10px;" :disabled="scope.row.status == 1"
                  ><img src="../../assets/imgs/publish.svg" style="width: 12px;margin-right: 5px;" v-if="scope.row.status == 0">
                   <img src="../../assets/imgs/unpublish.svg" style="width: 12px;margin-right: 5px;" v-if="scope.row.status == 1">
                  <span>公开</span></el-link
                >
                <el-link :underline="false" @click="handleDeleteFlashInfoById(scope.row)"
                  ><img src="../../assets/imgs/del.svg" style="width: 12px;margin-right: 5px;"><span>删除</span></el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="填料" prop="firstName" align="center" />
      <el-table-column label="上传时间" prop="createTime" align="center">
        <template slot-scope="scope">
          <div>{{ formatTime(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="系列" prop="secondName" align="center" />
      <el-table-column label="规格" prop="thirdName" align="center" />
      <el-table-column label="上传用户" prop="author" align="center" />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="450px"
      >
        <template slot-scope="scope">
          <el-link :underline="false" @click="handleRevise(scope.row)" style="margin-right: 10px;"
            ><img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>编辑</span></el-link
          >
          <el-link :underline="false" @click="handleAdd(scope.row)" style="margin-right: 10px;"
            ><img src="../../assets/imgs/add.svg" style="width: 12px;margin-right: 5px;"><span>添加分离柱</span></el-link
          >
          <el-link :underline="false" @click="handleDeleteCatalogues(scope.row)"
            ><img src="../../assets/imgs/del.svg" style="width: 12px;margin-right: 5px;"><span>删除</span></el-link
          >
          <el-link :underline="false" @click="handleRelease(scope.row)" v-if="scope.row.flashColumnInfoList.length>0"><i class="el-icon-upload el-icon" style="margin: 0 0 0 5px;color: #67c23a"></i><span>公开分离柱</span></el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" align="right" style="margin-top: 30px;">
      <el-pagination
        layout="prev,jumper,slot, next"
        :total="total"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      >
        <span style="display: inline;">/ </span>
        <span style="display: inline;">{{ pages }}</span>
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" center append-to-body @close="resetForm"> 
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">添加填料</span>
        </div>
      </div>
      <div v-for="(itemFirst, indexFirst) in addList" :key="indexFirst" class="list-box" style="width: 800px;">
        <el-form :model="itemFirst" :ref="`refForm${indexFirst}`" label-position="right" :inline="true" label-width="60px" style="width: 100%;">
          <div style="display: flex; align-items: flex-start;justify-content: space-between;">
            <div style="width: 250px;margin-top: 20px;">
              <el-form-item label="填料:" :prop="`catalogueName`" style="display: flex;" :rules="{required: true, message:'请输入填料名称',trigger:'blur'}"> 
                <el-input v-model="itemFirst.catalogueName" autocomplete="off" style="width: 150px;"></el-input>
                <div style="display: flex; align-items: center;margin-left: 10px;">
                  <i class="el-icon-error" style="color: #dadada;" @click="delFirst(indexFirst)"></i>
                </div>
              </el-form-item>
            </div>
            <div style="width:550px">
              <div v-for="(itemSecond, indexSecond) in itemFirst.childCatalogue" :key="indexSecond" class="list-center-box" :class="indexSecond === itemFirst.childCatalogue.length - 1 && 'list-center-box-noborder'">
                <div>
                  <el-form-item label="系列:" :prop="`childCatalogue[${indexSecond}].catalogueName`" style="display: flex;" :rules="{required: true, message:'请输入系列名称',trigger:'blur'}">
                    <el-input v-model="itemSecond.catalogueName" autocomplete="off" style="width: 150px;"></el-input>
                    <div style="display: flex; align-items: center;margin-left: 10px;">
                      <i class="el-icon-circle-plus" style="color: #1c94fa;margin-right: 5px;" @click="addSecond(indexFirst,indexSecond)" v-if="itemFirst.childCatalogue.length === 1 || indexSecond === itemFirst.childCatalogue.length - 1 "></i>
                      <i class="el-icon-error" style="color: #dadada;" @click="delSecond(indexFirst,indexSecond)"></i>
                    </div>
                  </el-form-item>
                </div>
                <div>
                  <div v-for="(itemThird, indexThird) in itemSecond.childCatalogue" :key="indexThird" style="display: flex; flex-direction: column;">
                    <el-form-item label="规格:" :prop="`childCatalogue[${indexSecond}].childCatalogue[${indexThird}].catalogueName`" style="display: flex;" :rules="{required: true, message:'请输入规格名称',trigger:'blur'}">
                      <el-input v-model="itemThird.catalogueName" autocomplete="off" style="width: 150px;" :title="itemThird.catalogueName"></el-input>
                      <div style="display: flex; align-items: center;margin-left: 10px;">
                        <i class="el-icon-circle-plus" style="color: #1c94fa;margin-right: 5px;" @click="addThird(indexFirst,indexSecond)" v-if="itemSecond.childCatalogue.length === 1 || indexThird === itemSecond.childCatalogue.length - 1 "></i>
                        <i class="el-icon-error" style="color: #dadada;" @click="delThird(indexFirst,indexSecond,indexThird)"></i>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </el-form>
      </div>
      <el-button type="primary" @click="addFirst" style="margin-top: 20px;margin-left: 40px;">添加填料</el-button>
      <div slot="footer" class="dialog-footer" style="padding-right: 40px; margin-bottom: 20px; text-align: right;">
        <el-button type="primary" @click="addSave">保存</el-button>
        <el-button type="primary" @click="cancelAdd">取消</el-button>
      </div>  
    </el-dialog>
    <el-dialog :visible.sync="dialogEditFormVisible" center append-to-body @close="resetEditForm('detailList')"> 
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">编辑填料</span>
        </div>
      </div>
      <div>
        <el-form
          :model="detailList"
          :rules="rules"
          ref="detailList"
          label-position="right"
          :inline="true"
          label-width="100px"
          :disabled="disabled"
        >
          <el-row style="width: 800px;">
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="填料:" prop="firstName">
                <el-input v-model="detailList.firstName" style="width: 250px;" :disabled="true"></el-input>
              </el-form-item>
            </el-col> 
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="系列:" prop="secondName">
                <el-input v-model="detailList.secondName" style="width: 250px;" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="规格:" prop="thirdName">
                <el-input v-model="detailList.thirdName" style="width: 250px;" :disabled="true" :title="detailList.thirdName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="分离柱名称:" prop="flashColumn">
                <el-input v-model="detailList.flashColumn" style="width: 250px;" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="选择供应商:" prop="supplierId">
                <el-select v-model="detailList.supplierId" placeholder="请选择" style="width: 250px;">
                  <el-option :label="item.supplierName" :value="item.id" v-for="(item ,index) in supplierList" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="最小流速:" prop="flowRate">
                <el-input v-model="detailList.flowRate" style="width: 250px;">
                  <div slot="append">ml/min</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="最大流速:" prop="flowRateMax">
                <el-input v-model="detailList.flowRateMax" style="width: 250px;">
                  <div slot="append">ml/min</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="类型:" prop="type">
                <el-select v-model="detailList.type" placeholder="请选择" style="width: 250px;">
                    <el-option label="正/反相柱" :value="2"></el-option>
                    <el-option label="正相柱" :value="1"></el-option>
                    <el-option label="反相柱" :value="0"></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="柱体积:" prop="cv">
                <el-input v-model="detailList.cv" style="width: 250px;">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="最大耐压:" prop="pressure">
                <el-input v-model="detailList.pressure" style="width: 250px;">
                  <div slot="append">psi</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="填料:" prop="filler">
                <el-input v-model="detailList.filler" style="width: 250px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="内径:" prop="innerDiameter">
                <el-input v-model="detailList.innerDiameter" style="width: 250px;">
                  <div slot="append">mm</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
            <el-form-item label="质量:" prop="weight">
              <el-input v-model="detailList.weight" style="width: 250px;">
                <div slot="append">g</div></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="柱高度:" prop="length">
                <el-input v-model="detailList.length" style="width: 250px;">
                  <div slot="append">mm</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="润柱体积:" prop="equilibriumVolume">
                <el-input v-model="detailList.equilibriumVolume" style="width: 250px;">
                  <div slot="append">CV</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="最小上样量:" prop="loadAmountMin">
                <el-input v-model="detailList.loadAmountMin" style="width: 250px;">
                  <div slot="append">g</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="最大上样量:" prop="loadAmountMax">
                <el-input v-model="detailList.loadAmountMax" style="width: 250px;">
                  <div slot="append">g</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="孔径:" prop="aperture">
                <el-input v-model="detailList.aperture" style="width: 250px;">
                  <div slot="append">Å</div></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 62px;">
              <el-form-item label="粒径:" prop="particleSize">
                <el-input v-model="detailList.particleSize" style="width: 250px;">
                  <div slot="append">μm</div></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="deep-box" style="width: 800px;">
            <el-col :span="12">
              <el-form-item label="拖尾因子:" prop="trailingFactor">
                <el-input v-model="detailList.trailingFactorMin" style="width: 120px;"></el-input>
                -
                <el-input v-model="detailList.trailingFactorMax" style="width: 120px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="有效塔板数:" prop="effectivePedals">
                <el-input v-model="detailList.effectivePedals" style="width: 250px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分离度:" prop="resolution">
                <el-input v-model="detailList.resolution" style="width: 250px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="柱床尺寸:" prop="columnBedSize">
                <el-input v-model="detailList.columnBedSize" style="width: 250px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="24" style="display: flex; justify-content: center; margin-bottom: 20px;">
            <el-form-item>
              <el-button type="primary" style="margin-right: 20px;width: 100px;" @click="save('detailList')">保存</el-button>
              <el-button type="primary" style="width: 100px;" @click="release('detailList')">公开</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogEditDetail" center append-to-body  @close="resetEditForm('editForm')">
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">编辑</span>
        </div>
      </div>
      <el-form
      :model="editForm"
      :rules="dialogEditRules"
      ref="editForm"
      label-position="right"
      :inline="true"
      label-width="100px"
    >
      <el-row style="width: 800px;">
        <el-col :span="24">
          <el-form-item label="填料:" prop="firstName">
            <el-input v-model="editForm.firstName" style="width: 550px;"></el-input>
          </el-form-item>
        </el-col> 
        <el-col :span="24">
          <el-form-item label="系列:" prop="secondName">
            <el-input v-model="editForm.secondName" style="width: 550px;"></el-input>
          </el-form-item>
        </el-col> 
        <el-col :span="24">
          <el-form-item label="规格:" prop="thirdName">
            <el-input v-model="editForm.thirdName" style="width: 550px;" :title="editForm.thirdName"></el-input>
          </el-form-item>
        </el-col> 
      </el-row>
      <el-col :span="24" style="padding-right: 40px; margin-bottom: 20px; text-align: right;">
        <el-form-item>
          <el-button type="primary" @click="updateCatalogues('editForm')">修改</el-button>
          <el-button @click="dialogEditDetail = false">取消</el-button>
        </el-form-item>
      </el-col>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'SepaColumnManagement',
  data() {
    var flashColumn = (rule, value, callback) => {
        if (value.length > 20) {
          callback(new Error('名称长度不超过20个字符'));
        } else {
          callback();
        }
      };
      var filler = (rule, value, callback) => {
        if (value === '') {
          callback();
        } else if (value.length > 255) {
          callback(new Error('填料长度不超过255个字符'));
        } else {
          callback();
        }
      };
var innerDiameter = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var cv = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var length = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (value.length > 10) {
          callback(new Error('总长不超过10个字符'));
          // 小数或整数
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else if (value <= 0) {
          callback(new Error('请输入正数'));
        } else {
          callback();
        }
      };
      var weight = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 999 ) {
              callback(new Error('小数部分不超过三位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var loadAmount = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9999 ) {
              callback(new Error('小数部分不超过四位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var pressure = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var flowRate = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var equilibriumVolume = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var aperture = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
        var columnBedSize= (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
           else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var trailingFactor= (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
    return {
      disabled: true,
      supplierListSelect: [],
      selectSupplierName: '',
      checked: [],
      firstSelection : [],
      secondSelection : [],
      addList: [],
      dialogFillerForm: [
        {
          id: null,
          catalogueName: '',
        },
        {
          id: null,
          catalogueName: '',
        },
        {
          id: null,
          catalogueName: '',
        },
      ],
      detailList: [],
      dialogEditRules: {
        firstName: [
          { required: true, message: '请输入填料名称', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ],
        secondName: [
          { required: true, message: '请输系列名称', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ],
        thirdName: [
          { required: true, message: '请输入规格名称', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ],
      },
      rules: {
        flashColumn: [
          { validator: flashColumn, trigger: 'blur' },
          { required: true, message: '请输入分离柱名称', trigger: 'blur' },
        ],
        filler: [
          { validator: filler, trigger: 'blur' }
        ],
        innerDiameter: [
          { validator: innerDiameter, trigger: 'blur' }
        ],
        cv: [
          { validator: cv, trigger: 'blur' },
          { required: true, message: '请输入柱体积', trigger: 'blur' },
        ],
        length: [
          { validator: length, trigger: 'blur' }
        ],
        weight: [
          { validator: weight, trigger: 'blur' }
        ],
        loadAmountMin: [
          { validator: loadAmount, trigger: 'blur' }
        ],
        loadAmountMax: [
          { validator: loadAmount, trigger: 'blur' }
        ],
        pressure: [
          { validator: pressure, trigger: 'blur' },
          { required: true, message: '请输入最大耐压', trigger: 'blur' },
        ],
        flowRate: [
          { validator: flowRate, trigger: 'blur' },
          { required: true, message: '请输入最小流速', trigger: 'blur' },
        ],
        flowRateMax: [
          { validator: flowRate, trigger: 'blur' },
          { required: true, message: '请输入最大流速', trigger: 'blur' },
        ],
        equilibriumVolume: [
          { validator: equilibriumVolume, trigger: 'blur' }
        ],       
        aperture: [
          { validator: aperture, trigger: 'blur' }
        ],
                columnBedSize: [
          { validator: columnBedSize, trigger: 'blur' }
        ],
        trailingFactorMax: [
          { validator: trailingFactor, trigger: 'blur' }
        ],
        trailingFactorMin: [
          { validator: trailingFactor, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择正反相柱', trigger: 'change' },
        ],
        effectivePedals: [
          { pattern: /^[0-9]*$/, message: '请输入数字', trigger: 'blur' },
        ],
        resolution: [
          { pattern: /^[0-9]*$/, message: '请输入数字', trigger: 'blur' },
        ],
      },
      pages: 1,
      supplierList: [],
      // 遮罩层
      loading: true,
      subTableDataLoading: false,
      // 总条数
      total: 0,
      // 表格数据
      queryList: [],
      // 查询参数
      queryParams: {
        selectStatus: null,
        pageNum: 1,
        pageSize: 10,
        author: this.$store.state.userId,
        supplierId: null,
        catalogueName: '',
      },
      // 子表格数据
      subTableData: [],
      dialogEditDetail: false,
      dialogEditFormVisible: false,
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',
      editForm: {},
      checkList: [],
      checkTwoLevelList: [],
    }
  },
  created() {
    this.getList()
    this.getSupplierList()
  },
  mounted() {
    document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = ''
  },
  methods: {
    inputChange() {
      this.supplierListSelect = this.supplierList.filter(item => {
        return item.supplierName.indexOf(this.selectSupplierName) > -1
      })
    },
    batchDetail(){
      this.checkTwoLevelList = []
      this.secondSelection = []
      this.checked.forEach((item,index) => {
        if(item) {
          this.checkTwoLevelList = [...this.checkTwoLevelList,(this.checkList[index])]
        }
      })
      this.checkTwoLevelList.forEach(item => {
        this.secondSelection = [...this.secondSelection,...item]
      })
      this.$confirm('确定批量删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteFlashInfoById', this.secondSelection, (res) => {
            if(res.data.code !== 200) {
              this.$message({
                type: 'error',
                message: '批量删除失败!'
              })
              return
            } else {
              this.$api.post('/datacenter/deleteCatalogues', this.firstSelection, (val) => {
                if(val.data.code !== 200) {
                  this.$message({
                    type: 'error',
                    message: '批量删除失败!'
                  })
                  return
                } else {
                  this.$message({
                    type: 'success',
                    message: '批量删除成功!'
                  })
                  this.getList()
                }
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消批量删除'
          })
        })
    },
    batchRelease(){
      this.checkTwoLevelList = []
      this.secondSelection = []
      this.checked.forEach((item,index) => {
        if(item) {
          this.checkTwoLevelList = [...this.checkTwoLevelList,(this.checkList[index])]
        }
      })
      this.checkTwoLevelList.forEach(item => {
        this.secondSelection = [...this.secondSelection,...item]
      })
      this.$confirm('确定批量公开吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/updateFlashInfoStatus', this.secondSelection, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '公开失败!'
                })
                return
              }
              this.$message({
                type: 'success',
                message: '公开成功!',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消公开',
          })
        })
    },
    selectionLineChangeHandle(val) {
      this.firstSelection = val.map(item => {
        return {firstId: item.firstId,secondId: item.secondId,thirdId: item.thirdId}
      })
    },
    selectionChangeHandle(val,list) {
      if(val.length > 0) {
        this.checked[this.getArrayIndex(this.queryList, list)] = true
        this.checkList[this.getArrayIndex(this.queryList, list)] = val.map(item => {
          return item.id
        })
      } else {
        this.checked[this.getArrayIndex(this.queryList, list)] = false
        this.checkList[this.getArrayIndex(this.queryList, list)] = []
      }
    },
    save(formName) {
      this.detailList.status = 0
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/updateFlashInfoById', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                return
              }
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.getList()
              this.dialogEditFormVisible = false
            }
          }) 
        } else {
          return false
        }
      })
    },
    release(formName) {
      this.detailList.status = 1
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/updateFlashInfoById', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  message: '公开失败',
                  type: 'error'
                })
                return
              }
              this.$message({
                message: '公开成功',
                type: 'success'
              })
              this.getList()
              this.dialogEditFormVisible = false
            }
          }) 
        } else {
          return false
        }
      })
    },
    resetEditForm(formName) {
      this.$refs[formName].resetFields()
    },
    cancelAdd() {
      this.resetForm()
      this.dialogFormVisible = false
      this.getList()
    },
    validateForm(refs){
        let valiForm = this.$refs[refs].validate?this.$refs[refs]:this.$refs[refs][0]
        return new Promise((resolve,reject)=>{
            //在Promise里进行验证，如果通过就resolve()
            valiForm.validate(res=>{
                if(res) resolve()
                else reject()
            })
        })
    },
    resetAddForm(refs){
        let valiForm = this.$refs[refs].validate?this.$refs[refs]:this.$refs[refs][0]
        return new Promise(()=>{
            //在Promise里进行验证，如果通过就resolve()
            valiForm.resetFields()
        })
    },
    resetForm() {
      Promise.all([
         //数组部分的表单，用map返回验证函数的调用
         ...this.addList.map((item,index)=>this.resetAddForm(`refForm${index}`))
     ])
    },
    addSave() {
      Promise.all([
         //数组部分的表单，用map返回验证函数的调用
         ...this.addList.map((item,index)=>this.validateForm(`refForm${index}`))
     ]).then(res=>{
        if(res) {
          this.$api.post('/datacenter/insertCatalogues', this.addList,res => {
            if (res.data) {
              if (res.data.code === 200) {
                this.$message({
                message: '添加成功',
                type: 'success'
                });
                this.dialogFormVisible = false
                this.resetForm()
                this.getList()
              } else {
                this.$message({
                  message: '添加失败',
                  type: 'error'
                });
                this.dialogFormVisible = false
                this.resetForm()
                this.getList()
              }         
            } 
          }
          ) // 全部表单验证通过
        }
      }).catch(err=>{
        console.log(err)
      })  
    },
    delThird(index, index2, index3) {
      if (this.addList[index].childCatalogue.length === 1 && this.addList[index].childCatalogue[index2].childCatalogue.length === 1 && this.addList.length === 1) {
        this.addList = [
        {
          catalogueName: '',
          parentCatalogueId: '',
          catalogueLevel: 1,
          author: this.$store.state.userId,
          childCatalogue: [
            {
              catalogueName: '',
              catalogueLevel: 2,
              author: this.$store.state.userId,
              childCatalogue: [
                {
                  catalogueName: '',
                  catalogueLevel: 3,
                  author: this.$store.state.userId,
                }
              ]
            },
          ]
        },
      ]
      } else if (this.addList[index].childCatalogue.length === 1 && this.addList[index].childCatalogue[index2].childCatalogue.length === 1 && this.addList.length !== 1) {
        this.addList.splice(index, 1)
      } else if (this.addList[index].childCatalogue.length !== 1 && this.addList[index].childCatalogue[index2].childCatalogue.length === 1) {
        this.addList[index].childCatalogue.splice(index2, 1)
      } else {
        this.addList[index].childCatalogue[index2].childCatalogue.splice(index3, 1)
      }
    },
    delSecond(index, index2) {
      if (this.addList[index].childCatalogue.length === 1 && this.addList.length === 1) {
        this.addList = [
        {
          catalogueName: '',
          parentCatalogueId: '',
          catalogueLevel: 1,
          author: this.$store.state.userId,
          childCatalogue: [
            {
              catalogueName: '',
              catalogueLevel: 2,
              author: this.$store.state.userId,
              childCatalogue: [
                {
                  catalogueName: '',
                  catalogueLevel: 3,
                  author: this.$store.state.userId,
                }
              ]
            },
          ]
        },
      ]
      } else if (this.addList[index].childCatalogue.length === 1 && this.addList.length !== 1) {
        this.addList.splice(index, 1)
      } else {
        this.addList[index].childCatalogue.splice(index2, 1)
      }
    },
    delFirst(index) {
      if (this.addList.length === 1) {
        this.addList = [
        {
          catalogueName: '',
          parentCatalogueId: '',
          catalogueLevel: 1,
          author: this.$store.state.userId,
          childCatalogue: [
            {
              catalogueName: '',
              catalogueLevel: 2,
              author: this.$store.state.userId,
              childCatalogue: [
                {
                  catalogueName: '',
                  catalogueLevel: 3,
                  author: this.$store.state.userId,
                }
              ]
            },
          ]
        },
      ]
      } else {
        this.addList.splice(index, 1)
      }
    },
    addThird(index, index2) {
      this.addList[index].childCatalogue[index2].childCatalogue.push({
        catalogueName: '',
        catalogueLevel: 3,
        author: this.$store.state.userId,
      })
    },
    addSecond(index) {
      this.addList[index].childCatalogue.push({
        catalogueName: '',
        catalogueLevel: 2,
        author: this.$store.state.userId,
        childCatalogue: [
          {
            catalogueName: '',
            catalogueLevel: 3,
            author: this.$store.state.userId,
          }
        ]
      },)
    },
    addFirst() {
      this.addList.push({
        catalogueName: '',
        parentCatalogueId: '',
        catalogueLevel: 1,
        author: this.$store.state.userId,
        childCatalogue: [
          {
            catalogueName: '',
            catalogueLevel: 2,
            author: this.$store.state.userId,
            childCatalogue: [
              {
                catalogueName: '',
                catalogueLevel: 3,
                author: this.$store.state.userId,
              }
            ]
          },
        ]
      },)
    },
    updateCatalogues(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogFillerForm[0].id = this.editForm.firstId
          this.dialogFillerForm[0].catalogueName = this.editForm.firstName
          this.dialogFillerForm[0].catalogueLevel = 1
          this.dialogFillerForm[1].id = this.editForm.secondId
          this.dialogFillerForm[1].catalogueName = this.editForm.secondName
          this.dialogFillerForm[1].catalogueLevel = 2
          this.dialogFillerForm[2].id = this.editForm.thirdId
          this.dialogFillerForm[2].catalogueName = this.editForm.thirdName
          this.dialogFillerForm[2].catalogueLevel = 3
          this.$api.post('/datacenter/updateCatalogues', this.dialogFillerForm, (res) => {
          if(res.data) {
            if(res.data.code !== 200) {
              this.$message({
                message: '修改失败',
                type: 'error'
              });
              return false
            }
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.dialogEditDetail = false
            this.getList()
          }
        })
        } else {
          return false
        }
      })
    },
    getArrayIndex(arr, obj) {
      var i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return i;
        }
      }
      return -1;
    },
    addPaddingList() {
      this.dialogFormVisible = true
      this.addList = [
        {
          catalogueName: '',
          parentCatalogueId: '',
          catalogueLevel: 1,
          author: this.$store.state.userId,
          childCatalogue: [
            {
              catalogueName: '',
              catalogueLevel: 2,
              author: this.$store.state.userId,
              childCatalogue: [
                {
                  catalogueName: '',
                  catalogueLevel: 3,
                  author: this.$store.state.userId,
                }
              ]
            },
          ]
        },
      ]
    },

    onReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        author: this.$store.state.userId,
        supplierId: null,
        catalogueName: '',
        selectStatus: null,
      },
      this.selectSupplierName = '',
      this.supplierListSelect = this.supplierList,
      this.getList()
    },

    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    getSupplierList () {
      this.$api.post('/datacenter/getSupplierList', {}, (res) => {
        if(res.data) {
          if(res.data.code !== 200) {
            this.$message({
              message: '获取供应商列表失败',
              type: 'error'
            });
            return false
          }
          this.supplierList = res.data.data
          this.supplierListSelect = res.data.data
        }
      }) 
    },
    getFlowRate(val1,val2) {
      // 中间加’-‘拼接
      return val1 + '-' + val2
    },
    handleEditDetail(row,props) {
      this.disabled = false
      this.dialogEditFormVisible = true
      // 对象合并
      this.detailList = Object.assign(JSON.parse(JSON.stringify(row)), props)
    },
    handleDetail(row,props) {
      this.disabled = true
      this.dialogEditFormVisible = true
      // 对象合并
      this.detailList = Object.assign(JSON.parse(JSON.stringify(row)), props)
    },
    handleCurrentChange(val) {
      console.log('sepa',val)
      this.queryParams.pageNum = val
      this.getList()
    },
    tableCellStyle() {
      return 'background-color: #f5f5f5'
    },
    tableHeaderCellStyle() {
      return 'background-color: #f5f5f5'
    },
    getMaxPressure(val) {
      // 保留小数点后两位
      return (val * 0.06894757).toFixed(2)
    },
    getSupplierName(id) {
      if (!id) {
        return '---'
      } else {
        if (this.supplierList.find(item => item.id === id)) {
          return this.supplierList.find(item => item.id === id).supplierName       
        } else {
          return '---'
        }
      }
    },
    formatTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleAdd(row) {
      this.$store.commit('updateSupplierId', this.queryParams.supplierId)
      this.$store.commit('updateRows', row)
      this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: '9-4',
      })
      this.$store.commit('updateTabs', {
        tag: 'add',
        tab: {
          name: 'sepa-add-specifications',
          title: '添加子规格',
        },
      })
    },
    // 用户编辑
    handleRevise(row) {
      this.editForm = Object.assign({}, row)
      this.dialogEditDetail = true
    },
    getSubTableData(row,expandedRows) {
      if(expandedRows.length > 0) {
        this.subTableDataLoading = true
        this.$api.post('/datacenter/getFlashList', {thirdCatalogueId: row.thirdId,author: row.author,supplierId:this.queryParams.supplierId,status:this.queryParams.selectStatus}, (res) => {
          if(res.data ) {
            if(res.data.code !== 200) {
              this.$message({
                message: '获取子规格列表失败',
                type: 'error'
              });
              return false
            }
            this.subTableData[this.getArrayIndex(this.queryList, row)] = res.data.data    
            this.subTableDataLoading = false    
          }
        })
      }
    },
    // 查询列表
    getList() {
      this.loading = true
      this.$api.post('/datacenter/getCatalogueInfoPage', this.queryParams, (res) => {
        if(res.data) {
          if(res.data.code !== 200) {
            this.$message({
              message: '获取列表失败',
              type: 'error'
            });
            this.loading = false
            return false
          }
          this.queryList = res.data.data.list
          this.total = res.data.data.total
          if (res.data.data.pages === 0) {
            this.pages = 1
          } else {
            this.pages = res.data.data.pages
          }
          res.data.data.list.forEach((item, index) => {
            this.$set(this.subTableData, index, [])
          }) 
          this.loading = false
          for(let i = 0; i < this.queryParams.pageSize; i++) {
            this.checked.push(false)
          }    
        }
      }) 
    },
    handleDeleteFlashInfoById(row) {
      this.$confirm('确定删除该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteFlashInfoById', [row.id], (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  message: '删除失败',
                  type: 'error'
                });
                return false
              }
              this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 删除数据
    handleDeleteCatalogues(row) {
      this.$confirm('确定删除该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteCatalogues', [{firstId: row.firstId,secondId: row.secondId,thirdId: row.thirdId}], (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  message: '删除失败',
                  type: 'error'
                });
                return false
              }
              this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 公开分离柱
    handleRelease(row){
      let element=[]
       for (let index = 0; index < row.flashColumnInfoList.length; index++) {
        if(row.flashColumnInfoList[index].status===0){
          element.push(row.flashColumnInfoList[index].id)
        }
        
       }
       if(element.length>0){
        this.$confirm('确定公开此规格下所有分离柱吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
        .then(() => {
          this.$api.post('/datacenter/updateFlashInfoStatus', element, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '公开失败!'
                })
                return
              }
              this.$message({
                type: 'success',
                message: '公开成功!',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消公开',
          })
        })
       }else{
          this.$message({
              type: 'error',
              message: '此规格下无待公开分离柱!'
            })
       }
    },
    handlePublish(row) {
      this.$confirm('确定公开该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/updateFlashInfoStatus', [row.id], (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  message: '公开失败',
                  type: 'error'
                });
                return false
              }
              this.$message({
                type: 'success',
                message: '公开成功!',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消公开',
          })
        })
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
  },
}
</script>

<style scoped>
.el-select .el-input {
  width: 230px;
}

.el-table .el-table__cell {
  text-align: center !important;
}
::v-deep .el-pagination__jump {
  margin-left: 0 !important;
}
::v-deep .el-input-group__prepend {
  width: 60px;
  background-color: #fff;
  border: 1 solid #dcdfe6 !important;
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
  margin-bottom: 20px;
}
::v-deep .el-dialog--center {
  height: auto;
  width: auto;
  max-height: 800px;
  overflow-y: auto;
  overflow-x: auto;
  max-width: 820px;
}
::v-deep .deep-box {
  background-color: #f5f5f5;
  padding-top: 23px;
  margin-bottom: 43px;
  box-sizing: border-box;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .list-box {
  padding-top: 20px !important;
  margin: 0 20px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #f5f5f5 !important;
}
::v-deep .list-center-box {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #f5f5f5 !important;
}
::v-deep .list-center-box-noborder {
  border-bottom: none !important;
}
::v-deep .list-box .el-form-item__content {
  display: flex;
}
::v-deep .sub-table .el-table__empty-block {
  background-color: rgb(245, 245, 245);
}
 .input-select /deep/ .el-input__inner {
  border: none !important;
}
::v-deep .el-link--inner {
  display: flex;
  align-items: center;
}
::v-deep .el-input input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
